import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CoreModule } from 'app/core/core.module';
import { AccessTypeListComponent } from './access-type-list.component';

@NgModule({
  imports: [
    CommonModule,
    CoreModule
  ],
  exports: [AccessTypeListComponent],
  declarations: [AccessTypeListComponent],
})
export class AccessTypeListModule { }
